import HelpUser from 'components/Container/HelpUser';
import IUserToken from 'interfaces/tokens/userToken';
import MoreIcon from 'mdi-react/MoreIcon';
import React, { useEffect, useState } from 'react';
import { titlePageService } from 'services/routes';

import { DrawerContext } from './context';
import Header from './Header';
import { useIsEduzzApp } from 'hooks';

export interface IMenu {
  path: string;
  icon?: typeof MoreIcon;
  display: string;
  isProducerRoute?: boolean;
  id: string;
  submenu?: IMenu[];
}

interface IProps {
  menu: IMenu[];
  user: IUserToken;
  classes?: any;
  children?: any;
}

const Drawer = ({ children, user }: IProps) => {
  const [, setDrawerOpened] = useState(false);
  const [titlePage, setTitlePage] = useState(['']);
  const isEduzzApp = useIsEduzzApp();

  useEffect(() => {
    titlePageService.get().subscribe({
      next: route => {
        setTitlePage(route.titlePage);
      },
    });
  }, []);

  const open = () => setDrawerOpened(true);
  const close = () => setDrawerOpened(false);

  return (
    <DrawerContext.Provider value={{ open, close }}>
      {!isEduzzApp && <Header user={user} titlePage={titlePage} />}
      <HelpUser />
      {children}
    </DrawerContext.Provider>
  );
};

export default Drawer;
